import { ValueOf } from 'types';

export const countries: Record<
    string,
    { code: string; code3: string; name: Record<string, string>; phraseId: number }
> = {
    int: {
        code: 'INT',
        code3: 'INT',
        name: {
            en: 'International',
        },
        phraseId: 17118,
    },
    us: {
        code: 'US',
        code3: 'USA',
        name: {
            en: 'United States of America',
        },
        phraseId: 15065,
    },
    ca: {
        code: 'CA',
        code3: 'CAN',
        name: {
            en: 'Canada',
            fr: 'Canada',
        },
        phraseId: 14870,
    },
    gb: {
        code: 'GB',
        code3: 'GBR',
        name: {
            en: 'United Kingdom',
        },
        phraseId: 14910,
    },
    au: {
        code: 'AU',
        code3: 'AUS',
        name: {
            en: 'Australia',
        },
        phraseId: 14845,
    },
    at: {
        code: 'AT',
        code3: 'AUT',
        name: {
            en: 'Austria',
            de: 'Österreich',
        },
        phraseId: 14844,
    },
    be: {
        code: 'BE',
        code3: 'BEL',
        name: {
            en: 'Belgium',
            fr: 'Belgique',
            nl: 'België',
        },
        phraseId: 14848,
    },
    br: {
        code: 'BR',
        code3: 'BRA',
        name: {
            en: 'Brazil',
            pt: 'Brasil',
        },
        phraseId: 14862,
    },
    dk: {
        code: 'DK',
        code3: 'DNK',
        name: {
            en: 'Denmark',
            da: 'Danmark',
        },
        phraseId: 14893,
    },
    fi: {
        code: 'FI',
        code3: 'FIN',
        name: {
            en: 'Finland',
            fi: 'Suomi',
        },
        phraseId: 14903,
    },
    fr: {
        code: 'FR',
        code3: 'FRA',
        name: {
            en: 'France',
            fr: 'France',
        },
        phraseId: 14906,
    },
    de: {
        code: 'DE',
        code3: 'DEU',
        name: {
            en: 'Germany',
            de: 'Deutschland',
        },
        phraseId: 14890,
    },
    in: {
        code: 'IN',
        code3: 'IND',
        name: {
            en: 'India',
            de: 'Inde',
            in: 'India',
        },
        phraseId: 14935,
    },
    it: {
        code: 'IT',
        code3: 'ITA',
        name: {
            en: 'Italy',
            it: 'Italia',
        },
        phraseId: 14942,
    },
    mx: {
        code: 'MX',
        code3: 'MEX',
        name: {
            en: 'Mexico',
            es: 'México',
        },
        phraseId: 14973,
    },
    nl: {
        code: 'NL',
        code3: 'NLD',
        name: {
            en: 'Netherlands',
            de: 'Niederlande',
            nl: 'Nederland',
        },
        phraseId: 14997,
    },
    nz: {
        code: 'NZ',
        code3: 'NZL',
        name: {
            en: 'New Zealand',
        },
        phraseId: 15001,
    },
    no: {
        code: 'NO',
        code3: 'NOR',
        name: {
            en: 'Norway',
            no: 'Norge',
        },
        phraseId: 14998,
    },
    pt: {
        code: 'PT',
        code3: 'PRT',
        name: {
            en: 'Portugal',
            pt: 'Portugal',
            br: 'Portugal',
        },
        phraseId: 15013,
    },
    es: {
        code: 'ES',
        code3: 'ESP',
        name: {
            en: 'Spain',
            es: 'España',
        },
        phraseId: 14900,
    },
    se: {
        code: 'SE',
        code3: 'SWE',
        name: {
            en: 'Sweden',
            sv: 'Sverige',
        },
        phraseId: 15041,
    },
    ch: {
        code: 'CH',
        code3: 'CHE',
        name: {
            en: 'Switzerland',
            de: 'Schweiz',
            fr: 'Suisse',
            it: 'Svizzera',
        },
        phraseId: 14872,
    },
} as const;

export const languages: Record<string, { id: number; name: Record<string, string>; code: string }> =
    {
        en: {
            id: 149,
            name: {
                en: 'English',
            },
            code: 'en',
        },
        da: {
            id: 144,
            name: {
                en: 'Danish',
                da: 'Dansk',
            },
            code: 'da',
        },
        fi: {
            id: 155,
            name: {
                en: 'Finnish',
                fi: 'Suomalainen',
            },
            code: 'fi',
        },
        fr: {
            id: 156,
            name: {
                en: 'French',
                fr: 'Français',
            },
            code: 'fr',
        },
        it: {
            id: 178,
            name: {
                en: 'Italian',
                it: 'Italiano',
            },
            code: 'it',
        },
        no: {
            id: 47,
            name: {
                en: 'Norwegian',
                no: 'Norsk',
            },
            code: 'no',
        },
        nl: {
            id: 147,
            name: {
                en: 'Dutch',
                nl: 'Nederlands',
            },
            code: 'nl',
        },
        es: {
            id: 81,
            name: {
                en: 'Spanish',
                es: 'Español',
            },
            code: 'es',
        },
        de: {
            id: 160,
            name: {
                en: 'German',
                de: 'Deutsch',
            },
            code: 'de',
        },
        pt: {
            id: 61,
            name: {
                en: 'Portuguese',
                pt: 'Português',
            },
            code: 'pt',
        },
        sv: {
            id: 85,
            name: {
                en: 'Swedish',
                sv: 'Svenska',
            },
            code: 'sv',
        },
    } as const;

export const localeDict: Record<
    string,
    { language: ValueOf<typeof languages>; country: ValueOf<typeof countries> }
> = {
    'en-INT': {
        language: languages['en'],
        country: countries['int'],
    },
    'en-AU': {
        language: languages['en'],
        country: countries['au'],
    },
    'nl-BE': {
        language: languages['nl'],
        country: countries['be'],
    },
    'fr-BE': {
        language: languages['fr'],
        country: countries['be'],
    },
    'pt-BR': {
        language: languages['pt'],
        country: countries['br'],
    },
    'en-CA': {
        language: languages['en'],
        country: countries['ca'],
    },
    'fr-CA': {
        language: languages['fr'],
        country: countries['ca'],
    },
    'da-DK': {
        language: languages['da'],
        country: countries['dk'],
    },
    'de-DE': {
        language: languages['de'],
        country: countries['de'],
    },
    'es-ES': {
        language: languages['es'],
        country: countries['es'],
    },
    'fr-FR': {
        language: languages['fr'],
        country: countries['fr'],
    },
    'it-IT': {
        language: languages['it'],
        country: countries['it'],
    },
    'es-MX': {
        language: languages['es'],
        country: countries['mx'],
    },
    'nl-NL': {
        language: languages['nl'],
        country: countries['nl'],
    },
    'de-NL': {
        language: languages['de'],
        country: countries['nl'],
    },
    'en-NZ': {
        language: languages['en'],
        country: countries['nz'],
    },
    'no-NO': {
        language: languages['no'],
        country: countries['no'],
    },
    'de-AT': {
        language: languages['de'],
        country: countries['at'],
    },
    'en-AT': {
        language: languages['en'],
        country: countries['at'],
    },
    'pt-PT': {
        language: languages['pt'],
        country: countries['pt'],
    },
    'de-CH': {
        language: languages['de'],
        country: countries['ch'],
    },
    'fr-CH': {
        language: languages['fr'],
        country: countries['ch'],
    },
    'it-CH': {
        language: languages['it'],
        country: countries['ch'],
    },
    'fi-FI': {
        language: languages['fi'],
        country: countries['fi'],
    },
    'sv-SE': {
        language: languages['sv'],
        country: countries['se'],
    },
    'en-GB': {
        language: languages['en'],
        country: countries['gb'],
    },
    'en-US': {
        language: languages['en'],
        country: countries['us'],
    },
    'en-IN': {
        language: languages['en'],
        country: countries['in'],
    },
} as const;
